import emailjs from '@emailjs/browser';

// Contact Form EmailJS Configuration
// Using the same credentials as your existing setup but with a separate template
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_868nett';
const EMAILJS_CONTACT_TEMPLATE_ID = 'template_llnihnx'; // New contact form template
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'tLLbISfeK4QbdmIJg';

// Initialize EmailJS for contact form service
if (EMAILJS_PUBLIC_KEY && EMAILJS_PUBLIC_KEY !== 'your_public_key_here') {
  emailjs.init(EMAILJS_PUBLIC_KEY);
  console.log('Contact Form EmailJS initialized successfully');
} else {
  console.warn('Contact Form EmailJS public key not found. Contact form will be simulated.');
}

export const contactFormService = {
  // Send contact form email
  async sendContactFormEmail(formData) {
    const { 
      name, 
      email, 
      practice, 
      subject, 
      message 
    } = formData;

    // Template parameters for EmailJS contact form template
    const templateParams = {
      name: name,
      email: email,
      practice: practice || 'Not specified',
      subject: subject || 'General Inquiry',
      message: message,
      to_email: 'info@smileconsent.co.uk', // Send to your business email
      from_name: name,
      from_email: email
    };

    try {
      // Check if EmailJS is properly configured
      if (!EMAILJS_PUBLIC_KEY || EMAILJS_PUBLIC_KEY === 'your_public_key_here') {
        // Demo mode - log the contact form instead of sending
        console.log('=== CONTACT FORM DEMO MODE ===');
        console.log('📧 REASON: EmailJS not configured properly');
        console.log('ℹ️  To enable real contact form sending:');
        console.log('   1. Check your .env file for REACT_APP_EMAILJS_PUBLIC_KEY');
        console.log('   2. Ensure EmailJS is properly configured');
        console.log('');
        console.log('Contact Form Submission:');
        console.log('Name:', name);
        console.log('Email:', email);
        console.log('Practice:', practice);
        console.log('Subject:', subject);
        console.log('Message:', message);
        console.log('Would send to: info@smileconsent.co.uk');
        console.log('===============================');
        return { success: true, message: 'Contact form simulated (EmailJS not configured)' };
      }

      // Add detailed logging before sending
      console.log('📧 Sending contact form email with EmailJS...');
      console.log('Service ID:', EMAILJS_SERVICE_ID);
      console.log('Template ID:', EMAILJS_CONTACT_TEMPLATE_ID);
      console.log('From:', name, '<' + email + '>');
      console.log('Subject:', subject);
      console.log('Template params:', templateParams);
      
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CONTACT_TEMPLATE_ID,
        templateParams
      );
      
      console.log('✅ Contact form email sent successfully');
      console.log('📨 EmailJS Response:', response);
      console.log('📧 Email sent to: info@smileconsent.co.uk');
      
      return { 
        success: true, 
        message: 'Contact form submitted successfully! We\'ll get back to you soon.',
        messageId: response.text
      };
    } catch (error) {
      console.error('Contact form email sending error:', error);
      
      // Provide helpful error messages
      let errorMessage = 'Failed to submit contact form';
      if (error.text?.includes('service ID not found')) {
        errorMessage = `EmailJS service ID "${EMAILJS_SERVICE_ID}" not found. Please check your EmailJS dashboard.`;
      } else if (error.text?.includes('template ID not found')) {
        errorMessage = `EmailJS template ID "${EMAILJS_CONTACT_TEMPLATE_ID}" not found. Please check your EmailJS dashboard.`;
      } else if (error.text?.includes('public key')) {
        errorMessage = 'Invalid EmailJS public key. Please check your configuration.';
      } else {
        errorMessage = `Failed to submit contact form: ${error.message || error.text || 'Unknown error'}`;
      }
      
      throw new Error(errorMessage);
    }
  }
};

// Make contact form service available globally for testing (optional)
if (typeof window !== 'undefined') {
  window.contactFormService = contactFormService;
}
